
import { Button } from "@/components/ui/button";
import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface MobileNavItemProps {
  icon: ReactNode;
  label: string;
  onClick: () => void;
  useCompactLabel?: boolean;
  isActive?: boolean;
  variant?: "ghost" | "default" | "outline" | "secondary" | "destructive" | "link";
  className?: string;
}

export function MobileNavItem({ 
  icon, 
  label, 
  onClick, 
  useCompactLabel = false,
  isActive = false,
  variant = "ghost",
  className = ""
}: MobileNavItemProps) {
  // Use compact label if specified (for smaller screens)
  const displayLabel = useCompactLabel && label.length > 6 ? label.substring(0, 5) : label;

  return (
    <Button
      variant={variant}
      size="sm"
      className={cn(
        "flex flex-col items-center gap-0.5 h-auto min-h-[52px] min-w-[52px] py-2 px-2 relative rounded-[22px] text-muted-foreground hover:bg-transparent transition-colors",
        isActive && "bg-secondary text-secondary-foreground hover:bg-secondary hover:text-secondary-foreground shadow-sm",
        className
      )}
      onClick={onClick}
    >
      {icon}
      <span className="text-[10px] font-semibold tracking-tight">{displayLabel}</span>
    </Button>
  );
}
